import { Link } from "react-router-dom";
const HotTopic2 = ({topic}) => {
    return(
        <button className=" bg-mainColor2 h-[25px] px-3 py-1 ml-4 mb-3 rounded-[50px] cursor-pointer">
            <div>
                <p textLevel={"h3-10"} className="text-nextColor font-IRANYekanMedium text-[10px]">
                   {topic}
                </p>
            </div>
        </button>
    )
}

export default HotTopic2;